import moment from 'moment/moment';

export const getLatestOpenDate = openEvents => {
  if (!Array.isArray(openEvents) || openEvents.length === 0) {
    return null;
  }

  const latestTimestamp = Math.max(...openEvents.map(event => event.time));

  return moment.unix(latestTimestamp).format('MM-DD-YYYY hh:mm A');
};
